import { ThunkAction } from "redux-thunk";
import { Dispatch, ActionCreator } from "redux";

import { RootState, AppDispatch } from "../store/store";
import { datasetType } from "../constanst/index";
import axiosInstance from "../utils/axiosInstance";
import { Exception } from "../types/exceptionType";
import { datasetsAction } from "./IDatasetsAction";

export const fetchDownloadUrlRequest = () => {
  return {
    type: datasetType.FETCH_DOWNLOAD_URL_REQUEST,
  };
};

export const fetchDownloadUrlSuccess = (data: string) => {
  return {
    type: datasetType.FETCH_DOWNLOAD_URL_SUCCESS,
    payload: data,
  };
};

export const fetchDownloadUrlFailure = (error: Exception) => {
  return {
    type: datasetType.FETCH_DOWNLOAD_URL_FAILURE,
    payload: error,
  };
};

export const fetchDatasetsRequest = () => {
  return {
    type: datasetType.FETCH_DATASETS_REQUEST,
  };
};

export const fetchDatasetsSuccess = (data: any) => {
  return {
    type: datasetType.FETCH_DATASETS_SUCCESS,
    payload: data,
  };
};

export const fetchDatasetsFailure = (error: Exception) => {
  return {
    type: datasetType.FETCH_DATASETS_FAILURE,
    payload: error,
  };
};

export const cleanDatasets = () => {
  return {
    type: datasetType.CLEAN_DATASETS,
  };
};
//cleanDatasetElements
export const cleanElements = () => {
  return {
    type: datasetType.CLEAN_DATASET_ELEMENTS,
  };
};

export const AddDataseToRoute = (data: any) => {
  return {
    type: datasetType.ADD_DATASET_ROUTE,
    payload: data,
  };
};

export const updateDataset = (data: any) => {
  return {
    type: datasetType.UPDATE_DATASET_ROUTE,
    payload: data,
  };
};

export const cleanDatasetRoute = () => {
  return {
    type: datasetType.CLEAN_DATASET_ROUTE,
  };
};

export const fetchDatasets: ActionCreator<
  ThunkAction<void, RootState, null, datasetsAction>
> = (
  datasetId: any,
  prefix: string | undefined = undefined,
  maxPageSize?: string | undefined,
  marker?: string | undefined,
  searchText?: string |undefined
) => {
  return (dispatch: Dispatch) => {
    /***if dataset has a prefix****/
    let body = {
      prefix: `${prefix ?? ""}/${searchText ?? ""}`,
      maxPageSize: maxPageSize ?? 20,
      marker: marker ?? "",
    };
    /*******************************/
    dispatch(fetchDatasetsRequest());
    axiosInstance({ method: "post", url: `/datasets/${datasetId}`, data: body })
      .then((response: any) => {
        /*const newData={
          elements:response.data.data
        }*/
        dispatch(fetchDatasetsSuccess(response.data.data));
      })
      .catch((error: any) => {
        const data: Exception = {
          status: error?.response?.status,
          message: error?.response?.message || "",
          data: error?.response?.data?.data || {},
        };
        dispatch(fetchDatasetsFailure(data));
      });
  };
};

export const fetchDownloadUrl: ActionCreator<
  ThunkAction<void, RootState, null, any>
> =
  (id: string, name: string, prefix?: string) =>
  async (dispatch: AppDispatch) => {
    try {
      const blobName = prefix! ? `${prefix}/${name}` : name;
      dispatch(fetchDownloadUrlRequest());
      const response = await axiosInstance.post(`/datasets/download/${id}`, {
        blobName: blobName,
      });
      const data: any = response.data;
      dispatch(fetchDownloadUrlSuccess(data));
      return data.data.url;
    } catch (error: any) {
      const data: Exception = {
        status: error.response.status,
        message: error?.response?.data,
        data: error.response?.data?.data,
      };
      dispatch(fetchDownloadUrlFailure(data));
      return error?.response?.data;
    }
  };

export const cleanUpDatasets = () => {
  return (dispatch: Dispatch) => {
    dispatch(cleanDatasets());
  };
};

export const cleanDatasetElements = () => {
  return (dispatch: Dispatch) => {
    dispatch(cleanElements());
  };
};

export const AddDataseRoute = (data: any) => {
  return (dispatch: Dispatch) => {
    dispatch(AddDataseToRoute(data));
  };
};

export const updateDatasetRoute = (data: any) => {
  return (dispatch: Dispatch) => {
    dispatch(updateDataset(data));
  };
};

export const cleanDatasetFromRoutes = () => {
  return (dispatch: Dispatch) => {
    dispatch(cleanDatasetRoute());
  };
};
